export default __webpack_public_path__ + "static/media/ar.99c25968.svg";